import UserData from '@services/Utilities/UserData';

export default {
  setUser(state, payload) {
    state.user = new UserData(payload);
  },
  changeBalance(state, balance) {
    state.user.changeBalance(balance);
  },
  logout(state) {
    state.user = new UserData();
  },
  setOnLineStatus(state, status) {
    state.isOnLine = status;
  },
};
